var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "accordion"
  }, [_c('div', {
    staticClass: "accordion__head",
    on: {
      "click": _vm.handleToggle
    }
  }, [_c('div', {
    staticClass: "accordion__title"
  }, [_vm._v(_vm._s(_vm.title))]), _c('div', {
    staticClass: "accordion__button"
  }, [_c('svg', {
    attrs: {
      "width": "15",
      "height": "9",
      "viewBox": "0 0 15 9",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "d": "M7.38672 8.4707C7.62402 8.4707 7.85254 8.37402 8.01074 8.19824L14.418 1.6416C14.5674 1.49219 14.6553 1.29004 14.6553 1.06152C14.6553 0.595703 14.2949 0.235352 13.8291 0.235352C13.6094 0.235352 13.3984 0.323242 13.2402 0.472656L7.39551 6.45801L1.54199 0.472656C1.38379 0.323242 1.18164 0.235352 0.944336 0.235352C0.478516 0.235352 0.118164 0.595703 0.118164 1.06152C0.118164 1.29004 0.206055 1.49219 0.364258 1.65039L6.77148 8.19824C6.94727 8.37402 7.14941 8.4707 7.38672 8.4707Z",
      "fill": "#636366"
    }
  })])])]), !_vm.isCollapse ? _c('div', {
    staticClass: "accordion__body"
  }, [_vm._t("default")], 2) : _vm._e()]);
}
var staticRenderFns = []

export { render, staticRenderFns }